export const isObject = (x) => typeof x === 'object' && !Array.isArray(x) && Object.keys(x).length > 0;
export const M_MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
];

/**
 * convert date to str
 * desc yy-mm-dd
 */
export const localDate = (date, short, withTime, usingNumber) => {
  if (!date) return '';
  const days = String(date).replace('T', ' ').split(' ');
  const times = withTime && days[1] ? days[1].split(':') : [];
  const temp = days[0].split('-');
  if (temp.length < 3) return String(date);

  const month = M_MONTHS[Number(temp[1]) - 1] || temp[1];
  const formattedDate = [temp[2], usingNumber ? temp[1] : short ? month.substr(0, 3) : month, temp[0]].join(
    usingNumber ? '/' : ' '
  );
  const formattedTime = withTime && times.length ? ` pkl. ${[times[0], times[1]].join(':')}` : '';
  return `${formattedDate}${formattedTime}`;
};

export const duration = (start, end, options) => {
  options = options || {};

  // set default options
  let str = '';
  const shortDate = !!options.shortDate;
  const separator = options.separator || '-';

  // format date
  if (typeof start === 'string') {
    start = new Date(start.replace(/-/g, '/'));
  } else if (!(start instanceof Date)) {
    start = new Date(start);
  }

  if (typeof end === 'string') {
    end = new Date(end.replace(/-/g, '/'));
  } else if (!(end instanceof Date)) {
    end = new Date(end);
  }

  if (!!start.getDate() && !!end.getDate()) {
    // same year
    if (start.getYear() === end.getYear()) {
      // same month
      if (start.getMonth() === end.getMonth()) {
        // same date
        if (start.getDate() === end.getDate()) {
          str = [
            start.getDate(),
            shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
            start.getFullYear(),
          ];

          // different date
        } else {
          str = [
            start.getDate(),
            separator,
            end.getDate(),
            shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
            start.getFullYear(),
          ];
        }

        // different month
      } else {
        str = [
          start.getDate(),
          shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
          separator,
          end.getDate(),
          shortDate ? M_MONTHS[end.getMonth()].substr(0, 3) : M_MONTHS[end.getMonth()],
          start.getFullYear(),
        ];
      }

      // different year
    } else {
      str = [
        start.getDate(),
        shortDate ? M_MONTHS[start.getMonth()].substr(0, 3) : M_MONTHS[start.getMonth()],
        start.getFullYear(),
        separator,
        end.getDate(),
        shortDate ? M_MONTHS[end.getMonth()].substr(0, 3) : M_MONTHS[end.getMonth()],
        end.getFullYear(),
      ];
    }

    str = str.join(' ');
  }

  return str;
};

export const getAge = (date) => {
  const today = new Date();
  const birthDate = new Date(date);
  const m = today.getMonth() - birthDate.getMonth();
  let age = today.getFullYear() - birthDate.getFullYear();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age = age - 1;
  }
  return `${age} th ${m} bln`;
};

export const getLatestDate = (array) =>
  new Date(
    Math.max(
      ...array.map((date) => {
        return new Date(date);
      })
    )
  );

export const pad = (number) => {
  let r = String(number);
  return r.length === 1 ? '0' + r : r;
};

export const dateToString = (date, useTime) => {
  if (!date || (date && typeof date !== 'object') || (date && typeof date === 'object' && isNaN(date.getTime())))
    return '';
  const str = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  const time = pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());

  return useTime ? [str, time].join(' ') : str;
};

/**
 * get value object by desc key
 * desc string with .
 */
export const getDeepObj = (obj, desc) => {
  const arr = desc.split('.');
  if (obj === null || obj === undefined) return '';
  while (arr.length && (obj = obj[arr.shift()])) {
    if (!arr.length) {
      return obj || {};
    }
  }
};

import httpBuildQuery from 'http-build-query';
export const queryString = (params, q = false) => {
  const str = httpBuildQuery(params);
  return q ? `?${str}` : str;
};

export const fAlamat = (arrayAlamat) => {
  const a = arrayAlamat;
  return `
  ${a[0] ? a[0] : ''}
  ${a[1] ? `RT ${a[1]}` : ''}
  ${a[2] ? `, RW ${a[2]}` : ''}
  ${a[3] ? `, Kel. ${a[3]}` : ''}
  ${a[4] ? `, Kec. ${a[4]}${a[5] ? '' : ''}` : ''}
  ${a[5] ? `<br/>${a[5]}${a[6] ? ' - ' : ''}` : ''}
  ${a[6] ? `Prov. ${a[6]}` : ''}
  `;
};

export const fkata = (array) => {
  return [array.slice(0, -1).join(', '), array.slice(-1)[0]].join(array.length < 2 ? '' : ' dan ');
};

/**
 * convert arr to obj
 * desc string with .
 */
export const isArray = (x) => x instanceof Array;
export const arrayToObject = (array, key) =>
  array.reduce((obj, item) => {
    obj[isArray(item) ? item[0] : item[`${key}`] || item.id || item.key] = item;
    return obj;
  }, {});

export const assetsUrl = (url) => {
  /* eslint-disable no-useless-escape */
  const pattern = new RegExp('^((http(s)?(://))|//)');
  url = pattern.test(url) ? url : require(`@/assets/img/${url}`);
  return url;
};

export const arrayFlat = (arr, d = 1) => {
  return d > 0
    ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? arrayFlat(val, d - 1) : val), [])
    : arr.slice();
};

export const chunkArray = (myArray, chunk_size) => {
  let results = [];
  while (myArray.length) {
    results.push(myArray.splice(0, chunk_size));
  }
  return results;
};

export const currency = (data, n, x, s, c) => {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = Number(data).toFixed(Math.max(0, ~~n));

  return (c ? num.replace(',', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || '.'));
};

export const filteredData = (data, key, filter) => {
  return data.filter((item) => item[key] === filter);
};
